import { gql } from '@apollo/client'

export const GET_COACH_ANALYTICS = gql`
  query CoachAnalytics($timeRange: PGACoachAnalyticsTimeRangeInput) {
    pgaCoachAnalytics(timeRange: $timeRange) {
      # Earnings analytics
      earnings {
        total
        byMonth {
          month
          total
        }
      }
      # Group events analytics
      groupEvents {
        revenue
        byMonth {
          month
          count
        }
        topEarningEvents(limit: 10) {
          groupEvent {
            id
            title
          }
          earnings
          registrationCount
        }
      }
      # Leads analytics
      leads {
        totalCount
        unviewedCount
        convertedCount
        conversionRate
        byMonth {
          month
          count
        }
      }
      # Private lesson analytics
      privateLessonTypes {
        revenue
        totalTypes
        byMonth {
          month
          count
        }
        topBooked(limit: 10) {
          lessonType {
            id
            title
          }
          lessonCount
          uniqueStudentCount
          earnings
        }
      }
    }
  }
`
